const TournamentsTypes = {
    GET_TOURNAMENTS_START:'GET_TOURNAMENTS_START',
    GET_TOURNAMENTS_SUCCESS:'GET_TOURNAMENTS_SUCCESS',
    GET_TOURNAMENTS_FAILED:'GET_TOURNAMENTS_FAILED',

}

export default TournamentsTypes